import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { INBOX_API_KEY } from '@/src/components/project/Inbox2/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { GetInboxSuggestionsResponseDto } from './dto/GetInboxSuggestionsResponse.dto';

export interface GetInboxSuggestions {
  projectId: string;
  searchTerm: string;
}

export interface UseInboxSuggestions {
  projectId: string;
  searchTerm: string;
  config?: MutationConfig<typeof getInboxSuggestions>;
}

const url = `${PREFIX_URL}/projects/:projectId/inbox/suggestions`;

export const getInboxSuggestions = ({
  projectId,
  searchTerm,
}: GetInboxSuggestions): Promise<GetInboxSuggestionsResponseDto> => {
  return axios.get(generateRoutePath(url, { projectId }, { search: searchTerm }));
};

export const inboxSuggestionsKeys = {
  all: ['inboxSuggestionsKeys'] as const,
  detail: (params: { projectId: string; searchTerm?: string }) =>
    [INBOX_API_KEY, ...inboxSuggestionsKeys.all, { ...params }] as const,
};

export const useInboxSuggestions = ({ projectId, searchTerm, config }: UseInboxSuggestions) => {
  return useMutation({
    onSuccess: (data) => {
      queryClient.setQueryData(
        [...inboxSuggestionsKeys.detail({ projectId, searchTerm })],
        (prev: any) => {
          return {
            ...prev,
            data,
          };
        }
      );

      queryClient.invalidateQueries([...inboxSuggestionsKeys.detail({ projectId, searchTerm })]);
    },

    ...config,

    mutationFn: ({ searchTerm }) => getInboxSuggestions({ projectId, searchTerm }),
  });
};
